export default __webpack_public_path__ + "static/media/pic9.a2b9d3fc.jpg";